class CYOSBuilder extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      productCardAction: '[data-build-set-product="product-selection"]',
      selectedProducts: '[data-build-set-product="selected-products"]',
      productCard: '[data-build-set="product-card"]',
      removeCard: '[data-build-set-product="remove-product"]',
      itemCount: '[data-build-set-product="item-count"]',
      setPrice: '[data-build-set-product="set-price"]',
      setSalePrice: '[data-build-set-product="set-sale-price"]',
      addToCart: '[data-build-set-product="custom-add-to-cart"]',
      giftProduct: '[data-build-set-product="gift-product"]',
      sidebarToggle: '[data-build-set-product="sidebar-toggle"]'
    };
    this.setProductTitle = this.getAttribute("data-build-set-title") || '';
    this.setProductImage = this.getAttribute("data-build-set-image") || '';
    this.maxSelections = parseInt(this.querySelector(this.selectors.selectedProducts).getAttribute("max-selection"));
    this.maxSelectionDiscount = parseInt(this.querySelector(this.selectors.selectedProducts).getAttribute("max-selection-discount"));

    this.minSelectionsForCart = parseInt(this.querySelector(this.selectors.selectedProducts).getAttribute("min-selection"));
    this.minSelectionDiscount = parseInt(this.querySelector(this.selectors.selectedProducts).getAttribute("min-selection-discount"));

    // Cache the discount information
    this.discounts = {
      [this.minSelectionsForCart]: this.minSelectionDiscount / 100,
      [this.maxSelections]: this.maxSelectionDiscount / 100,
    };
    this.titleMaxLength = 29;
    this.selectedProducts = [];
    this.existingCartProducts = [];

    this.isUpdatingCart = false;
    this.giftProductStatus =
      this.querySelector(this.selectors.giftProduct)?.getAttribute(
        "data-gift-product"
      ) || false;
    this.querySelector('[data-build-set="filter-list"]').addEventListener(
      "click",
      this.handleFilterClick.bind(this)
    );
    this.querySelector(this.selectors.sidebarToggle)?.addEventListener(
      "click",
      this.handleSidebarToggle.bind(this)
    );
    this.checkInitialCartState();
    document.addEventListener("cyos-cart:updated", () => {
      this.checkInitialCartState();
    });
  }

  connectedCallback() {
    this.setupUI();
    this.setupEventListeners();
    this.removeSelectedProducts();
  }

  setupUI() {
    this.productCardsAction = this.querySelectorAll(
      this.selectors.productCardAction
    );
    this.selectedProductsDisplay = this.querySelector(
      this.selectors.selectedProducts
    );
    this.itemCountElement = this.querySelector(this.selectors.itemCount);
    this.setPriceElement = this.querySelector(this.selectors.setPrice);
    this.addToCartButton = this.querySelector(this.selectors.addToCart);
  }

  setupEventListeners() {
    this.productCardsAction.forEach((card) => {
      card.addEventListener("click", this.handleProductSelection.bind(this));
    });
    this.addToCartButton.addEventListener(
      "click",
      this.handleAddToCart.bind(this)
    );
  }

  async checkInitialCartState(type) {
    this.selectedProducts = [];
    this.existingCartProducts = [];
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const cart = await response.json();
      let cyos_oos_status = false;
      cart.items.forEach((item) => {
        // Check for the custom property and quantity
        if (
          item.properties &&
          item.properties["_is_cyos"] === "true" &&
          item.quantity === 1
        ) {
          const matchingCard = this.querySelector(
            `product-card[data-variant-id="${item.variant_id}"]`
          );
          // With variant-level eligibility a cart item's variant may no longer be
          // in the eligible list, so there may be no matching tile on the page.
          if (matchingCard) {
            const input = matchingCard.querySelector(this.selectors.productCardAction);
            let existItem = {
              variantId: item.variant_id,
              title: item.product_title,
              price: item.price,
              image: item.image,
              variantTitle: item.variant_title,
              key: item.key,
            };
            if (
              matchingCard
                .querySelector('[data-build-set-product="product-selection"]')
                ?.getAttribute("disabled")
            ) {
              existItem["outOfStock"] = true;
              matchingCard.dataset.buildSetSelected = "oos";
              cyos_oos_status = true;
              if(input) input.checked = false; 
            } else {
              matchingCard.dataset.buildSetSelected = "true";
              if(input) input.checked = true;
            }
            this.selectedProducts.push(existItem);
            this.existingCartProducts.push(existItem);
            this.isUpdatingCart = true;
          }
        } else if (
          item.properties &&
          item.properties["_is_cyos_gift"] === "true" &&
          item.quantity === 1
        ) {
          let existItem = {
            variantId: item.variant_id,
            gift: "true",
            price: item.price,
            key: item.key,
          };

          this.selectedProducts.push(existItem);
          this.existingCartProducts.push(existItem);
        }
      });
      if (this.selectedProducts.length === 0) {
        this.querySelectorAll('[data-build-set-product="product-card"]').forEach(
          (card) => {
            const input = card.querySelector(this.selectors.productCardAction);
            card.dataset.buildSetSelected = card.dataset.buildSetSelected === "true" ? "false" : card.dataset.buildSetSelected;
            if(input) input.checked = false;

          }
        );
      }
      if (cyos_oos_status) {
        this.querySelector(".build-set__error-banner").classList.remove("hidden");
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      if (type != "reload") {
        this.updateUIState();
      }
    }
  }

  removeSelectedProducts() {
    this.selectedProductsDisplay.addEventListener("click", (event) => {
      const removeButton = event.target.closest(this.selectors.productCard).querySelector(
          this.selectors.removeCard
      );
      if (removeButton) {
        const unSelectedCard = removeButton.closest(
          ".build-set__selected-product-card"
        );
        if (unSelectedCard) {
          const variantId = unSelectedCard.dataset.variantId;
          const productCardInList = this.querySelector(
            `product-card[data-variant-id="${variantId}"]`
          );
          this.removeProduct(productCardInList, variantId);
          this.updateUIState();
        }
      }
    });
  }

  async handleProductSelection(event) {
    const button = event.currentTarget;
    const card = button.closest("product-card");
    const variantId = card.dataset.variantId;
    const isSelected = card.dataset.buildSetSelected === "true";

    if (!variantId) {
      console.error("Product card missing variant ID");
      return;
    }

    if (isSelected) {
      this.removeProduct(card, variantId);
    } else if (this.selectedProducts.filter(p => !p.gift).length < this.maxSelections) {
      const productTitle = card.dataset.productTitle;
      const variantTitle = card.dataset.variantTitle;
      const productPrice = parseInt(card.dataset.productPrice);
      const productImageSrc = card.querySelector("img").src;

      this.addProduct(card, {
        id: variantId,
        title: productTitle,
        price: productPrice,
        image: productImageSrc,
        variantTitle: variantTitle,
      });
    } else {
      // Provide user feedback that max items are selected
      document.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: `You can select a maximum of ${this.maxSelections} items.`,
            tone: "error",
            duration: 4000,
          },
        })
      );
    }
    this.updateUIState();
  }

  addProduct(card, variantData) {
    const product = {
      variantId: variantData.id,
      title: variantData.title,
      price: variantData.price,
      image: card.querySelector("img").src,
      variantTitle: variantData.variantTitle,
    };
    this.selectedProducts.push(product);
    card.dataset.buildSetSelected = "true";
  }

  removeProduct(card, variantId) {
    const input = card.querySelector(this.selectors.productCardAction);
    this.selectedProducts = this.selectedProducts.filter(
      (p) => p.variantId != variantId
    );
    card.dataset.buildSetSelected = card.dataset.buildSetSelected === "oos" ? "oos" : "false";
    if(input) input.checked = false;
  }

  updateUIState() {
    if (this.giftProductStatus) {
      this.updateGiftProduct();
    }
    this.updateAddToCartButton();
    this.updateSelectedProductsDisplay();
    this.updateItemCountText();
    this.updatePriceDisplay();
    this.updateProductCardsDisabledState();
    this.updateProgressBar();
  }

  updateAddToCartButton() {
    const oosProducts = this.selectedProducts.filter(
      (product) => product.outOfStock
    );
    const isEnabled = this.selectedProducts.length >= this.minSelectionsForCart;
    this.addToCartButton.disabled = !isEnabled;
    const buttonContent = this.addToCartButton.querySelector("button-content");
    if (this.isUpdatingCart) {
      buttonContent.textContent = "Update Set";
    }
    if (isEnabled) {
      const btnText = this.addToCartButton.querySelector("button-content").getAttribute('button-text');
      this.addToCartButton.querySelector("button-content").textContent = btnText;
    } else {
      let btnText = `Add ${this.minSelectionsForCart} Items to set`;
      if (window.innerWidth < 1000) {
        btnText = `Add ${this.minSelectionsForCart} Items`;
      }
      this.addToCartButton.querySelector(
        "button-content"
      ).textContent = btnText;
    }
    if (oosProducts.length > 0) {
      this.addToCartButton.disabled = true;
    } else {
      if (
        !this.querySelector(".build-set__error-banner").classList.contains(
          "hidden"
        )
      ) {
        this.querySelector(".build-set__error-banner").classList.add("hidden");
      }
    }
  }

  updateSelectedProductsDisplay() {
    const selectedCards = this.selectedProductsDisplay.querySelectorAll(
      ".build-set__selected-product-card"
    );
    const nonGiftProducts = this.selectedProducts.filter(
      (product) => !product.gift
    );

    selectedCards.forEach((card, index) => {
      const selectedProduct = nonGiftProducts[index];
      const imageContainer = card.querySelector(
        ".build-set__selected-product-image"
      );
      const titleElement = card.querySelector(
        ".build-set__selected-product-name"
      );
      const discountTextElement = card.querySelector(
        ".build-set__selected-product-promo"
      );
      const variantTitleElement = card.querySelector(
        ".build-set__selected-variant-title"
      );

      if (selectedProduct) {
        card.setAttribute("data-variant-id", selectedProduct.variantId);
        const productCard = this.querySelector( '[data-build-set-product="product-card"][data-variant-id="'+selectedProduct.variantId+'"]');
        const getVarTitleVal = productCard.getAttribute('data-variant-title');
        imageContainer.innerHTML = `<img src="${selectedProduct.image}" alt="${selectedProduct.title}">`;
        const title = selectedProduct.title;
        const ellipseTitle =  title.length > this.titleMaxLength ? title.slice(0, this.titleMaxLength) + "..." : title;
        titleElement.textContent = ellipseTitle;
        let variantTitle = selectedProduct.variantTitle;
        if(getVarTitleVal){ variantTitle = getVarTitleVal; }
        if (variantTitle && variantTitle.includes("oz.")) {
          const split_title = variantTitle.split("|");
          variantTitle = split_title[split_title.length - 1];
        }
        if (selectedProduct.outOfStock) {
          variantTitle = "Out of Stock";
          variantTitleElement.classList.add("text-error");
        } else if (variantTitleElement.classList.contains("text-error")) {
          variantTitleElement.classList.remove("text-error");
        }
        variantTitleElement.textContent = variantTitle;
        card.classList.add("is-selected");
        // Clear discount text if not applicable
        if (discountTextElement) discountTextElement.style.display = "none";
      } else {
        card.setAttribute("data-variant-id", "");
        imageContainer.innerHTML = "";
        titleElement.textContent = `Add Item`;
        variantTitleElement.textContent = "";
        card.classList.remove("is-selected");
        // Restore discount text visibility based on original index
        const originalIndex = Array.from(selectedCards).indexOf(card) + 1;
        if (
          discountTextElement &&
          (originalIndex === this.minSelectionsForCart ||
            originalIndex === this.maxSelections)
        ) {
          discountTextElement.style.display = "";
        }
      }
    });
  }

  updateItemCountText() {
    const itemsToAdd = this.minSelectionsForCart - this.selectedProducts.length;
    let text;
    if (itemsToAdd > 0) {
      text = `Add ${this.minSelectionsForCart} items`;
    } else {
      text = `Total`;
    }
    this.itemCountElement.textContent = text;
  }

  updatePriceDisplay() {
    const priceElement = this.querySelector(this.selectors.setPrice);
    const discountPriceElement = this.querySelector(
      this.selectors.setSalePrice
    );
    const nonGiftProducts = this.selectedProducts.filter(
      (product) => !product.gift
    );
    let selectedCount = nonGiftProducts.length;
    // Calculate total price based on selected items
    const subtotal = nonGiftProducts.reduce((sum, item) => sum + item.price, 0);
    let finalPrice = subtotal;

    let discountPercentage = 0;
    let discountIndex = selectedCount;
    discountPriceElement.textContent = "";
    if (selectedCount > this.maxSelections) {
      discountIndex = this.maxSelections;
    } else if (
      selectedCount > this.minSelectionsForCart &&
      selectedCount < this.maxSelections
    ) {
      discountIndex = this.minSelectionsForCart;
    }
    if (this.discounts[discountIndex]) {
      const subtotalFormattedPrice = this.formatPrice(subtotal);
      discountPriceElement.textContent = subtotalFormattedPrice;
      discountPercentage = this.discounts[discountIndex];
      finalPrice = subtotal * (1 - discountPercentage);
    }

    const formattedPrice = this.formatPrice(finalPrice);
    priceElement.textContent = formattedPrice;
  }

  updateProductCardsDisabledState() {
    const isMaxSelected = this.selectedProducts.filter(p => !p.gift).length >= this.maxSelections;
    this.querySelectorAll('[data-build-set-product="product-card"]').forEach(
      (card) => {
        const button = card.querySelector(
          '[data-build-set-product="product-selection"]'
        );
        const is_disabled = card.classList.contains("disabled");
        const isCardSelected = card.dataset.buildSetSelected === "true";

        // disable cards that are not already selected
        if ((isMaxSelected && !isCardSelected) || is_disabled) {
          button.disabled = true;
        } else {
          button.disabled = false;
        }
      }
    );
  }

  updateProgressBar() {
    const allSteps = this.querySelectorAll(".build-set-step");
    const progressBar = this.querySelector(".build-set-status-bar");

    if (!progressBar) return;
    const nonGiftProducts = this.selectedProducts.filter(
      (product) => !product.gift
    );

    let percentage = 0;
    let progresSteps = this.maxSelections;
    let selectedCount = nonGiftProducts.length;
    if (this.giftProductStatus) {
      progresSteps = progresSteps + 1;
    }
    if (selectedCount == this.maxSelections) {
      percentage = 100;
      selectedCount = selectedCount + 1;
    } else if (selectedCount > 1) {
      percentage = ((selectedCount - 1) / (progresSteps - 1)) * 100;
    }
    progressBar.style.width = `${percentage}%`;

    // Update steps based on the number of selected products
    allSteps.forEach((step, index) => {
      if (index < selectedCount) {
        step.classList.add("build-set-step--active");
      } else {
        step.classList.remove("build-set-step--active");
      }
    });
  }

  updateGiftProduct() {
    const nonGiftProducts = this.selectedProducts.filter(
      (product) => !product.gift
    );
    const hasGiftItem = this.selectedProducts.some(
      (item) => item.gift === "true"
    );
    const giftProduct = this.querySelector(this.selectors.giftProduct);
    if (nonGiftProducts.length >= this.minSelectionsForCart) {
      if (!hasGiftItem) {
        let gift_variant_id = giftProduct.dataset.giftId;
        const gift_product_data = {
          variantId: gift_variant_id,
          gift: "true",
          price: parseInt(giftProduct.dataset.productPrice),
        };
        this.selectedProducts.push(gift_product_data);
        giftProduct.classList.remove("is-disabled");
      }
      if (giftProduct.classList.contains("is-disabled")) {
        giftProduct.classList.remove("is-disabled");
      }
    } else {
      if (hasGiftItem) {
        this.selectedProducts = this.selectedProducts.filter(
          (item) => !item.gift
        );
        giftProduct.classList.add("is-disabled");
      }
    }
  }

  formatPrice(price) {
    // function ensures the price is formatted correctly, converting from cents
    return (price / 100).toLocaleString('en-US', {
      style: "currency",
      currency: window.Shopify.currency.active,
      currencyDisplay: 'symbol'
    });
  }

  async handleAddToCart(event) {
    event.preventDefault();
    if (this.minSelectionsForCart > this.selectedProducts.length) {
      document.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: `Please select minimum ${this.minSelectionsForCart} items.`,
            tone: "error",
            duration: 4000,
          },
        })
      );
      return false;
    }
    this.addToCartButton.disabled = true;
    this.addToCartButton.setAttribute("aria-busy", "true");
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true })
    );

    try {
      const promises = [];
      const fetchData = async(url, payload) => {
        const response = await fetch(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
          });
        
          if (!response.ok) {
            const errorData = await response.json();
            throw { status: response.status, message: errorData.message || "Unknown error" };
          }
        
          return response.json();
      }

      // Identify items to remove
      const itemsToRemove = this.existingCartProducts.filter((existingItem) => {
        const isNoLongerSelected = !this.selectedProducts.some(
          (selectedItem) =>
            String(selectedItem.variantId) === String(existingItem.variantId)
        );
        const isUnwantedGift = !this.giftProductStatus && existingItem.gift;
        return isNoLongerSelected || isUnwantedGift;
      });

      if (itemsToRemove.length > 0) {
        const updates = {};
        itemsToRemove.forEach((item) => {
          if (item.key) {
            updates[item.key] = 0;
          }
        });
        if (Object.keys(updates).length > 0) {
          promises.push(await fetchData(`${window.Shopify.routes.root}cart/update.js`, { updates }));
        }
      }

      // Identify items to add
      const newItemsToAdd = this.selectedProducts.filter(
        (selectedItem) =>
          !this.existingCartProducts.some(
            (existingItem) =>
              String(existingItem.variantId) === String(selectedItem.variantId)
          )
      );

      if (newItemsToAdd.length > 0) {
        const addItemsPayload = {
          items: newItemsToAdd.map((product) => {
            if (product.gift == "true") {
              return {
                id: product.variantId,
                quantity: 1,
                properties: { _is_cyos_gift: "true" },
              };
            } else {
              return {
                id: product.variantId,
                quantity: 1,
                properties: { 
                  _is_cyos: "true",
                  _cyos_title: this.setProductTitle,
                  _cyos_image: this.setProductImage
                },
              };
            }
          }),
        };

        promises.push(await fetchData(`${window.Shopify.routes.root}cart/add.js`, addItemsPayload));
      }
      await Promise.all(promises);

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { 
        bubbles: true,
        detail: {
          openGwpDrawer: true
        }
      }));
      document.querySelector('[aria-controls="cart-drawer"]').click();
    } catch (error) {
      console.error("Error updating cart:", error);
      const message = error.message || "Something went wrong while updating the cart.";
      document.dispatchEvent(
        new CustomEvent("toast:show", {
          detail: {
            message: message,
            tone: "error",
            duration: 4000,
          },
        })
      );
      window.location.reload();
    } finally {
      this.addToCartButton.disabled = false;
      this.addToCartButton.removeAttribute("aria-busy");
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      this.checkInitialCartState("reload");
    }
  }

  // Handles the click event for all filter buttons
  handleFilterClick(event) {
    event.preventDefault();
    const button = event.target.closest('[data-build-set="filter"]');
    if (!button) return;

    this.querySelectorAll('[data-build-set="filter"]').forEach((btn) =>
      btn.classList.remove("is-active")
    );
    button.classList.add("is-active");

    const filterValue = button.dataset.filterBy;
    const allProducts = this.querySelectorAll(
      '[data-build-set-product="product-card"]'
    );
    let visibleProductCount = 0;
    allProducts.forEach((card) => {
      const productCategory = card.dataset.productCategory;
      if (filterValue === "all" || productCategory === filterValue) {
        card.style.display = "";
        visibleProductCount++;
      } else {
        card.style.display = "none";
      }
    });
    const productCountElement = this.querySelector("[data-product-count]");
    if (productCountElement) {
      productCountElement.textContent = visibleProductCount;
    }
  }

  handleSidebarToggle() {
    const toggleIcon = this.querySelector(this.selectors.sidebarToggle);
    const productsContainers = this.querySelectorAll(
      ".build-set__selected-products"
    );

    if (toggleIcon && productsContainers) {
      toggleIcon.classList.toggle("is-active");
      productsContainers.forEach((selectedProductsContainer) => {
        if (
          selectedProductsContainer.style.display === "none" ||
          selectedProductsContainer.style.display === ""
        ) {
          selectedProductsContainer.style.display = "flex";
        } else {
          selectedProductsContainer.style.display = "none";
        }
      });
    }
  }
}

customElements.define("cyos-builder", CYOSBuilder);
